const ACTION_PREFIX = 'expense/temporary'
const CREATE_TEMP = `${ACTION_PREFIX}/create`
const REMOVE_TEMP = `${ACTION_PREFIX}/remove`

const initialState = () => ({
  temporaryExpense: {},
})

export default function reducer(state = initialState(), action) {
  switch (action.type) {
    case CREATE_TEMP: {
      const { data } = action
      const { id } = data

      return {
        ...state,
        temporaryExpense: { id },
      }
    }

    case REMOVE_TEMP: {
      return {
        ...state,
        temporaryExpense: {},
      }
    }

    default: {
      return state
    }
  }
}

export const createTemporary = (data) => ({ type: CREATE_TEMP, data })
export const removeTemporary = (data) => ({ type: REMOVE_TEMP, data })
